<template>
  <div class="page">
    <div class="wrapper">
      <div class="header">用户服务协议及隐私政策</div>
      <div class="title mb50">
        尊敬的用户：
      </div>
      <div class="title mb50">
        在您成为立吉投票注册用户，使用立吉投票提供的服务之前，请您认真阅读本
        <span>《用户服务协议及隐私政策》</span
        >，更好的了解我们所提供的服务以及您享有的权利和承担的义务。您一旦开始使用立吉投票服务，即表示您已经确认并接受了本文件中的全部条款。
      </div>
      <div v-for="(item, index) in agreementInfo" :key="index">
        <div class="mtitle">{{ item.mtitle }}</div>
        <div v-for="(cItem, cIndex) in item.content" :key="cIndex">
          <div :class="cItem.desc || cItem.noSpace ? 'title' : 'title mb50'">
            {{ cItem.title }}
          </div>
          <div v-if="cItem.desc" class="mb50">
            <div
              class="desc"
              v-for="(dItem, dIndex) in cItem.desc"
              :key="dIndex"
            >
              {{ dItem }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>武汉从心信息科技有限公司</div>
        <div>2018年6月6日</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPc } from "@/utils/common";
export default {
  data() {
    return {
      isMobile: true,
      agreementInfo: [
        {
          mtitle: "第一部分 用户服务协议",
          content: [
            {
              title: "生效日期：2018年6月6日",
              noSpace: true
            },
            {
              title:
                "本用户服务协议（以下简称“协议”）系由您与武汉从心信息科技有限公司（以下简称“立吉投票”或“我们”），就我们提供的立吉投票软件所订立的相关权利义务规范。请您在注册、使用立吉投票之前，应认真阅读以下条款："
            }
          ]
        },
        {
          mtitle: "定义",
          content: [
            {
              title:
                "用户：在手机、平板电脑、电脑等电子客户端注册成为立吉投票微信小程序（以下简称“立吉投票”“立吉投票平台”亦或“平台”）的使用者，通过立吉投票发布、查看、接收图文/音频/视频信息或其他文件，或可与其他用户进行延时/实时交流的终端用户（以下简称“用户”）。"
            },
            {
              title:
                "平台方：武汉从心信息科技有限公司，一家为用户提供立吉投票软件服务的公司 （以下简称“平台方）。"
            }
          ]
        },
        {
          mtitle: "第一条 注册条款的接受",
          content: [
            {
              title:
                "一旦您在注册页面点击或勾选“阅读并同意接受用户服务协议及隐私政策”相关内容后，即表示您已经阅读并且同意与我们达成协议，成为立吉投票的用户，并接受本用户服务协议中的全部注册条款以及第二部分《隐私政策》中的所有条款的约束。"
            }
          ]
        },
        {
          mtitle: "第二条 用户注册",
          content: [
            {
              title:
                "2.1 用户下载立吉投票并根据立吉投票的注册规则完成注册程序（包括但不限于设置用户名称及密码）后，即有权通过立吉投票发布、查看、接收图文/音频/视频信息或其他文件，或可与其他用户进行延时/实时交流。用户在立吉投票上有效注册（或不时有效变更注册）的用户名及密码（以下简称“用户名及密码”），共同构成用户通过立吉投票发布、查看、接收图文/音频/视频信息或其他文件，或可与其他用户进行延时/实时交流的唯一有效身份证明。"
            },
            {
              title:
                "2.2 用户一旦完成注册，则视为用户允许平台方的小程序或者公众号等推送或其他方式向其发送与立吉投票相关的信息。"
            },
            {
              title:
                "2.3 用户应当保证其完成上述注册（或不时的有效变更注册）时所提供的身份信息及电话等必要信息真实、准确、有效；如该等信息有任何变动，用户应当在三（3）日内通过立吉投票完成信息更新。因用户提供虚假或无效信息导致平台方或其他用户遭受损失的，用户应当承担全部的赔偿责任。"
            },
            {
              title:
                "2.4 用户应妥善保管用户名及密码，除经平台方事先书面同意或本协议另有约定外，不得将其赠予、转让、出售或出借于他人使用；如用户发现其用户名及密码遭他人使用，应立即通知平台方以避免损失或损失扩大。因网络攻击、用户保管用户名及密码不当、转让或出借用户名及密码、怠于履行本协议及其他相关协议下的通知义务等情形或其他非平台方原因，导致用户未能根据本协议使用立吉投票或遭受任何损失的，均由用户自行承担，平台方不承担任何责任。"
            },
            {
              title:
                "2.5 用户确认，在用户开始注册使用立吉投票前，用户应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若用户不具备前述与用户行为相适应的民事行为能力，则用户及用户的监护人应依照法律规定承担因此而导致的一切后果（未成年人阅读时应得到其监护人的陪同）。"
            },
            {
              title:
                "2.6 用户注册的账户为用户自行设置并由用户保管，平台方任何时候均不会主动要求用户提供账户密码。用户账户因用户的主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，平台方并不承担责任，用户应通过司法、行政等救济途径向侵权行为人追偿。"
            },
            {
              title:
                "2.7 如用户注册的账户符合以下条件，则平台方可回收用户注册的账户，用户将不能再登录立吉投票平台，相应服务同时终止；",
              desc: [
                "（一）经发现非由注册用户本人实际使用的；",
                "（二）连续三个月未用于登录立吉投票平台；",
                "（三）其他平台方认为有必要的情形。"
              ]
            },
            {
              title:
                "2.8 用户一旦完成注册，即视为完全了解、接受并同意遵守本协议项下的全部内容并受限于本协议相关条件和条款。平台方有权根据法律法规、政策以及运营中的实际情况对协议进行修改，并对用户进行公布。修改后的协议条款一经平台方公布即代替本协议的原条款，构成用户与平台方之间就本协议的全部、最新协议。用户可以随时在立吉投票应用程序中查阅最新协议条款。如果用户不接受平台方修改后的最新协议条款，请立即停止使用立吉投票。如用户选择继续使用立吉投票，则视为用户完全了解、接受并同意遵守平台方修改后的最新协议条款。用户承认并认可，已经完全了解并理解本协议相关内容，对本协议及相关内容不存在任何重大误解；同时认可本协议内容并不存在显失公平的情形，用户与平台方在协议中处平等地位，用户对协议的接受与否具有自由选择的权利。"
            }
          ]
        },
        {
          mtitle: "第三条 服务内容",
          content: [
            {
              title:
                "3.1 平台方为用户提供发布、查看、接收图文/音频/视频信息或其他文件，或可与其他用户进行延时/实时交流的服务。"
            },
            {
              title:
                "3.2 平台方作为立吉投票软件的设计/开发/所有/经营者，有权对于立吉投票软件不时作出更新和调整，只要用户仍为立吉投票的注册用户，即视为其同意平台方作出的任何变更和更新。"
            },
            {
              title:
                "3.3 平台方仅为用户提供发布、查看、接收图文/音频/视频信息或其他文件，或可与其他用户进行延时/实时交流的技术支持，因用户自身原因造成的延迟确认、延迟回复、未按时保存、操作失误等情形，平台方不承担任何责任。"
            },
            {
              title:
                "3.4 用户应当知晓在使用立吉投票软件的过程中可能存在由其他用户进行通知、提醒、审批、定时、评论、发起调查、投票等行为设置，平台方仅为前述行为提供技术支持，前述行为均为用户自身行为，与平台方无关。"
            },
            {
              title:
                "3.5 用户应当知晓在使用立吉投票软件的过程中可能涉及第三方服务软件的参与（包括但不限于微信、QQ、支付宝等），因前述第三方服务软件所造成的信息提供错误、信息提供延误、信息泄露、连接错误、服务器故障等情形与平台方无关。"
            }
          ]
        },
        {
          mtitle: "第四条 各方的权利义务",
          content: [
            { title: "4.1 用户的权利义务 " },
            {
              title:
                "4.1.1 用户应遵守中国有关的法律法规规定及本协议下的相关义务。"
            },
            {
              title:
                "4.1.2 用户向立吉投票平台提供的各类信息应真实、准确、完整；用户在立吉投票发布的各类信息（包括但不限于图文、音频、视频等）应符合中国有关的法律法规；用户通过立吉投票进行的延时/实时交流活动应当符合中国有关的法律法规。经平台方发现用户违反前述约定的，用户向立吉投票平台提供/发布的信息将不再适用本合同有关隐私保护的约定，平台方有权公示、向政府部门进行举报或直接向用户追究法律责任。平台方在任何时候有权验证用户提供/发布的信息，由于用户提供虚假或不完整信息所导致的任何责任和损失，应由用户承担。"
            },
            {
              title:
                "4.1.3 用户利用立吉投票平台发布虚假、侵犯他人隐私、侵犯他人知识产权、侮辱他人、造谣诽谤等违反法律法规或公德良俗的内容从而给平台方、其他用户或第三方造成损害的，由前述用户承担全部赔偿责任。"
            },
            {
              title:
                "4.1.4 用户不得有任何损害平台方权益的行为，若用户损害平台方权益的，平台方有权要求用户承担赔偿责任，情节严重的平台方将保留追究法律责任的权利。"
            },
            {
              title:
                "4.1.5 用户不得利用本协议项下平台方和其他用户从事违法违规活动，也不得要求平台方和其他用户进行违法违规活动。"
            },
            {
              title:
                "4.1.6 用户应当保证发布/查看、接收图文/音频/视频信息或其他文件时是自愿的。"
            },
            {
              title:
                "4.1.7 平台方暂时免费向用户提供本协议约定之服务，但平台方保留将来向用户收取费用的权利。用户之间产生的任何费用支付均与平台方无关。"
            },
            { title: "4.2 平台方的权利义务" },
            {
              title:
                "4.2.1 立吉投票平台提供用户发布或接受信息/文件并与立吉投票平台及时联接的终端设备（包括但不限于手机、平板电脑、电脑等电子客户端）中的应用程序，并在立吉投票平台的变更、更新、优化后，及时通知或协助用户更新终端设备中的应用程序。"
            },
            {
              title:
                "4.2.2 各方同意，立吉投票平台无法保证其所提供的信息中没有任何错误、缺陷、恶意软件或病毒。对于因使用（或无法使用）立吉投票平台导致的任何损害，立吉投票平台不承担责任（除非此类损害是由立吉投票平台的故意或重大疏忽造成的）。此外，对于因使用（或无法使用）与立吉投票平台的电子通信手段导致的任何损害，包括但不限于因电子通信传达失败或延时、第三方或用于电子通信的计算机程序对电子通信的拦截或操纵，以及病毒传输导致的损害，立吉投票平台不承担责任。"
            }
          ]
        },
        {
          mtitle: "第五条 其他责任约定",
          content: [
            {
              title:
                "5.1 因不可预测或无法克服的原因导致平台方未能按约提供服务的，平台方不承担责任。"
            },
            {
              title:
                "5.2 服务过程中因协议各方以外的其他方原因造成的损失，由该其他方承担赔偿责任。"
            }
          ]
        },
        {
          mtitle: "第六条 用户信息",
          content: [
            {
              title:
                "6.1 用户个人信息包括但不限于下列信息：用户真实姓名、性别、职业、任职/就读学校、头像、手机号码、IP地址等。"
            },
            {
              title:
                "6.2 用户非个人信息包括但不限下列信息：一切属于第6.1条所述的用户个人信息范围以外的信息，均为普通信息，不属于用户个人信息；包括但不限于用户对立吉投票服务的操作状态、使用记录、使用习惯等反应在平台方服务器端的全部记录信息。"
            },
            {
              title:
                "6.3 重要提示：为向客户提供本协议所述服务，平台方将可能合理使用用户个人信息和非用户个人信息（前述合称“用户信息”）。用户一旦注册、登录、使用立吉投票，将视为用户完全了解、同意并接受平台方通过包括但不限于收集、统计、分析、使用等方式合理使用用户信息，无需其他意思表示。为向用户完整地提供包括但不限于本协议所述的服务，平台方将可能要求用户上传用户信息（包括但不限于通讯录等），用户一旦选择上传用户信息，将视为用户完全了解、同意并接受平台方基于向用户提供服务的目的读取并合理使用用户信息。"
            },
            {
              title:
                "6.4 用户认可其已完全了解平台方使用用户信息的目的在于为用户提供包括本协议所述的服务或将来可能新增的服务，平台方使用用户信息的方式包括但不限于：收集、统计、分析、商业用途的使用等方式；平台方使用用户信息的范围包括但不限于本条第6.1条、6.2条、6.3条所定义的信息等。"
            },
            {
              title:
                "6.5 平台方对用户信息的使用无需向用户支付任何费用，并且在用户同意本协议的基础上，无需向用户另行取得授权。"
            },
            {
              title:
                "6.6 平台方尊重用户的合法权利，不会以违反法律、行政法规以及本协议约定的方式收集、使用用户信息。同时，平台方不会主动向使用立吉投票软件过程中涉及的任何第三方提供用户信息。如第三方需要通过平台获取用户信息的，平台方将以显著的方式告知用户，并取得用户的同意。"
            },
            {
              title:
                "6.7 非因平台方违反本协议的约定而导致的用户信息的泄露与平台方无关。任何用户（包括但不限于教师身份用户、家长身份用户、学生身份用户）不得利用、泄露、散播通过立吉投票平台获取的其他用户的用户信息；用户发生前述行为的，平台方不承担任何责任，由前述侵权用户承担全部责任。任何平台方、用户外的第三人不得利用、泄露、散播通过立吉投票平台获取的其他用户的用户信息，第三人发生前述行为的，平台方不承担任何责任，由前述侵权方承担全部责任。"
            },
            {
              title:
                "6.8 平台方对因不可抗力、按照有关法律法规要求、按照相关政府主管部门/司法机关的要求而披露用户信息的行为不承担任何责任。"
            }
          ]
        },
        {
          mtitle: "第七条 未成年人个人信息",
          content: [
            {
              title:
                "7.1 根据平台方提供的服务，平台方合理使用的用户信息中可能包含未成年人个人信息。"
            },
            {
              title:
                "7.2 平台方将在遵守《隐私政策》相关规定的情况下，按照本协议约定使用未成年人个人信息。"
            }
          ]
        },
        {
          mtitle: "第八条 知识产权",
          content: [
            {
              title:
                "8.1 知识产权是指与立吉投票服务相关的各种类的过去有效的、现行有效的、或即将产生的知识产权，包括但不限于商标、著作权、计算机软件、发明、实用新型、外观设计以及相关申请的权利。"
            },
            {
              title:
                "8.2 平台方为与立吉投票服务相关的全部知识产权的权利人，对立吉投票服务提供过程中包含的全部知识产权，包括但不限于任何文本、图片、图形、音频和/或视频资料享有及保留完整、独立的全部权利。未经平台方同意，用户及第三人不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行平台方享有的知识产权或者平台方提供的任何资料和信息，也不得将前述资料和信息用于任何商业目的。"
            },
            {
              title:
                "8.3 对于用户本人创作并上传到立吉投票的任何图文/音频/视频等，平台方保留对其内容进行实时监控的权利，并有权依平台方独立判断对任何违反本协议约定或涉嫌违法、违规的内容实施删除。平台方对于删除用户作品引起的任何后果或导致用户的任何损失不负任何责任。"
            },
            {
              title:
                "8.4 知识产权条款持续有效，不因用户关闭立吉投票账户或者停止使用立吉投票服务而失效。"
            }
          ]
        },
        {
          mtitle: "第九条 其他免责声明",
          content: [
            {
              title:
                "9.1 平台方或用户提供的全部信息仅依照该等信息提供时的现状提供并仅供用户参考，平台方不对前述信息的真实性、准确性、完整性、适用性等做任何承诺和保证。用户应对平台方或其他用户提供的信息自行判断，并承担因使用前述信息而引起的任何、全部风险，包括因其对信息的真实性、准确性、完整性或适用性的任何依赖或信任而导致的风险。平台方无需对因用户使用信息的任何行为导致的任何损失承担责任。"
            },
            {
              title:
                "9.2 由于用户以违法、违规或违反本协议约定等任何方式使用立吉投票的行为，包括但不限于提供违法、不真实、不正当信息，侵犯第三方任何合法权益等，给平台方或其他第三人造成的任何损失，用户同意承担由此造成的全部损害赔偿责任。"
            },
            {
              title:
                "9.3 用户完全了解并同意，在使用立吉投票服务的过程中，可能存在来自任何其他用户的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为，也可能存在对他人权利（包括知识产权）造成侵犯的匿名、冒名、或伪造的各种信息或行为，用户须自行判断相关内容、信息、行为的安全性等风险，并自行独立承担上述风险给平台方、其他用户或第三方造成的任何责任。"
            },
            {
              title:
                "9.4 平台方及其合作方对立吉投票服务的任何及全部内容不作任何形式的承诺或保证，不论是明确的或暗示的。前述承诺或保证包括但不限于：立吉投票服务真实性、时效性、对特定用途的适用性、任何形式的所有权保证，非侵权保证等。平台方对因前述未做承诺或保证的内容导致的任何直接、间接、偶然、特殊及后续的损害，不承担任何责任。"
            }
          ]
        },
        {
          mtitle: "第十条 适用法律和争议解决",
          content: [
            {
              title:
                "10.1 本协议的成立、生效、履行、解释及因本协议产生的任何争议，均适用中华人民共和国法律（不包括港澳台地区法律）。"
            },
            {
              title:
                "10.2 用户和平台方之间与本协议有关的任何争议，首先应友好协商解决，在争议发生之日起三十日内仍不能通过协商达成一致的，用户在此同意将前述争议提交平台方所在地的人民法院进行诉讼。"
            },
            {
              title:
                "10.3 如本协议中的任何条款因任何原因完全或部分无效或不具有执行力，均不影响本协议其他条款的效力。"
            },
            {
              title:
                "10.4本协议及本协议任何条款内容的最终解释权及修改权归平台方所有。"
            }
          ]
        },
        {
          mtitle: "第二部分《用户隐私政策》",
          content: [
            { title: "生效日期：2018年6月6日", noSpace: true },
            {
              title:
                "欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。本《用户隐私政策》将帮助您了解以下内容："
            }
          ]
        },
        {
          mtitle: "一、引言",
          content: [
            {
              title:
                "为了切实保护立吉投票用户隐私权，优化用户体验，立吉投票根据现行法规及政策，制定本《用户隐私政策》。本《用户隐私政策》将详细说明立吉投票在获取、管理及保护用户个人信息方面的政策及措施。本《用户隐私政策》适用于立吉投票向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的立吉投票服务。"
            },
            {
              title:
                "本《用户隐私政策》旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。我们希望您在使用立吉投票产品或服务前，请您务必仔细阅读并透彻理解本《用户隐私政策》，在确认充分理解并同意后使用相关产品或服务。如果您为未成年人，则您应在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用立吉投票并向立吉投票提供个人信息。如果您或监护人不同意本隐私政策任何内容，您应立即停止使用立吉投票产品或服务。一旦您开始使用立吉投票产品或服务，即表示您已充分理解并同意本政策。另外，在我们更新本《用户隐私政策》后，您继续使用我们的产品或服务，即意味着您同意本《用户隐私政策》(含更新版本)内容，并且同意我们按照本《用户隐私政策》收集、使用、保存和共享您的相关信息。"
            }
          ]
        },
        {
          mtitle: "二、我们收集哪些信息",
          content: [
            {
              title:
                "在您使用立吉投票提供的以下服务或功能过程中，我们将收集以下必要的相关个人信息，以及部分您可以选择提供的个人信息。"
            },
            { title: "1. 微信授权进入小程序的信息", noSpace: true },
            {
              title:
                "您首先需要成为微信的正式用户，在微信中只有您点击”微信授权登陆“后，才能进入立吉投票。您微信授权时，包含但不限于的信息有：微信头像、微信ID、微信昵称以及设备属性信息（如操作系统版本、设备型号、等软硬件特征信息）、设备位置信息（如通过小程序接口获得的位置信息）、设备连接信息（如通过小程序接口获得访问时间）等。"
            },
            {
              title:
                "2. 您在使用过程中上传的信息，例如参与信息、作业、评论、分享，等主动填写的信息。"
            },
            { title: "3. 根据您授权后采用合法方式收集的其他个人信息。" }
          ]
        },
        {
          mtitle: "三、我们如何使用Cookie和同类技术",
          content: [
            {
              title:
                "为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含用户身份标识符以及一些字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的服务。我们不会将 Cookie 用于本《用户隐私政策》所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该等修改，无法登录或使用我们的服务或功能。您可以通过更改您的浏览器设置限制立吉投票对Cookie的使用。以Chrome浏览器为例，您可以在Chrome浏览器右上方的下拉菜单的“浏览器设置”中，通过“设置-高级-清楚浏览数据”，选择清除您的Cookie。"
            }
          ]
        },
        {
          mtitle: "四、我们如何使用微信小程序本地缓存",
          content: [
            {
              title:
                "为确保小程序本地运行效果，我们会调用微信小程序平台接口进行本地缓存的读写与清理，有关接口详情，请参见微信小程序开发平台 developers.weixin.qq.com。"
            }
          ]
        },
        {
          mtitle: "五、我们如何使用收集到的信息",
          content: [
            {
              title:
                "收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：",
              desc: [
                "1.向您提供您使用的各项产品或服务；",
                "2.帮助我们设计新产品或服务，改善现有的产品或服务；",
                "3.在我们提供产品或服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；",
                "4.帮助我们更加了解您使用我们产品和服务的情况，从而针对性的回应您的个性化需求，以便为您提供服务、个性化内容和建议。",
                "5.向您推荐您可能感兴趣的内容，以及提供产品和服务的广告。",
                "6.评估广告和其他促销、推广活动的效果并加以改善",
                "7.经您许可的其他用途。"
              ]
            }
          ]
        },
        {
          mtitle: "六、我们如何共享、转让、公开披露您的个人信息",
          content: [
            {
              title:
                "我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。"
            },
            { title: "（一）共享", noSpace: true },
            {
              title:
                "我们会以高度的勤勉义务对待您的信息。除以下情形外，未经您同意，我们不会与除武汉从心信息科技有限公司及其关联公司外的任何第三方公司、组织和个人分享您的信息：我们可能将我们按照本隐私政策收集的您的设备信息（如IMEI、MAC地址等）提供给我们的关联公司、合作伙伴或第三方服务提供方，用作下列用途：",
              desc: [
                "（1）向您提供更好的客户服务和用户体验；",
                "（2）实现我们收集、使用您的信息的目的；",
                "（3）行使和履行我们在用户服务协议、本隐私政策或平台其他规则中规定的我们的权利和义务；",
                "（4）理解、维护和改善我们的产品及服务。"
              ]
            },
            { title: "(二）转让", noSpace: true },
            {
              title:
                "我们不会将您的个人信息转让给除武汉从心信息科技有限公司及其关联公司外的任何公司、组织和个人，但以下情形除外：",
              desc: [
                "1.事先获得您的明确授权或同意；",
                "2.满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；",
                "3.如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此用户隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意"
              ]
            },
            { title: "（三）公开披露", noSpace: true },
            {
              title: "我们仅会在以下情形下，公开披露您的个人信息：",
              desc: [
                "1.获得您的明确同意；",
                "2.基于法律法规、法律程序、诉讼或政府主管部门强制性要求下"
              ]
            },
            { title: "（四）例外情形", noSpace: true },
            {
              title:
                "在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：",
              desc: [
                "1. 与国家安全、国防安全直接相关的；",
                "2. 与公共安全、公共卫生、重大公共利益直接相关的；",
                "3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；",
                "4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
                "5. 您自行向社会公众公开的个人信息；",
                "6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。",
                "7. 根据个人信息主体要求签订和履行合同所必需的；",
                "8. 用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；",
                "9. 法律法规规定的其他情形。",
                "10. 根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。"
              ]
            }
          ]
        },
        {
          mtitle: "七、您的权力",
          content: [
            {
              title:
                "按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：访问和修改您的个人信息",
              desc: [
                "1. 访问修改名字：个人中心>编辑资料> 修改名字",
                "2. 访问修改手机号：个人中心>编辑资料> 修改手机号",
                "3. 如果您无法通过上述链接访问该等个人信息，您可以与我们联系。",
                "4. 您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以通过上述段落中列明的方式提出更正或补充申请。"
              ]
            }
          ]
        },
        {
          mtitle: "八、我们如何存储您的信息",
          content: [
            {
              title:
                "我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，并按照中国中华人民共和国法律法规、部门规章等规定的存储期限存储您的个人信息。"
            }
          ]
        },
        {
          mtitle: "九、我们如何保护您的信息",
          content: [
            {
              title:
                "1. 我们非常重视您的个人信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于采取信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。"
            },
            {
              title:
                "2. 尽管有上述第1款的约定，但是请您理解并明白，由于存在各种各样无法预知或现有技术无法防御的恶意手段，即便我们已经尽力采取必要的保护措施，您的信息仍有可能被泄露、毁损或灭失。如您发现您的账号、密码因任何原因已经或者将要泄露时，您应当立即跟我们联系，以便我们可以及时采取应对措施防止或减少您的相关损失。"
            },
            {
              title:
                "3. 如果我们发生企业合并、分立等情形的，则您的信息将由届时存续的企业主体继续履行保护义务，并由我们以公告等方式通知您；如果我们的产品、服务停止运营的，则我们将及时停止继续收集您的信息，并以公告等方式通知您，届时我们将对您的信息进行删除或隐匿化处理。"
            }
          ]
        },
        {
          mtitle: "十、未成年人保护",
          content: [
            {
              title:
                "我们重视未成年人的信息保护，如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许，父母或监护人明确同意或者保护未成年人所必要的情况下使用，共享，转让或披露此信息。我们将根据国家相关法律法规及本《用户隐私政策》的规定保护未成年人的个人信息。"
            }
          ]
        },
        {
          mtitle: "十一、您的个人信息如何进行跨境转移",
          content: [
            {
              title:
                "原则上，我们在中国境内收集和产生的个人信息仅存储在中国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。"
            }
          ]
        },
        {
          mtitle: "十二、本政策如何更新",
          content: [
            {
              title:
                "我们可不定期修改本隐私政策，变更后的隐私政策将在修订生效前通过立吉投票平台公告或以其他适当方式通知您。该情况下，若您继续使用我们的服务，即表示同意受经修订的隐私政策的约束。"
            }
          ]
        },
        {
          mtitle: "十三、争议管辖",
          content: [
            {
              title:
                "1.本隐私政策的签订、生效、履行、争议的解决均适用中华人民共和国法律。"
            },
            {
              title:
                "2.有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.isMobile = getPc();
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  background: #ffffff;
  font-size: 14px;
  height: auto;
  width: auto;
  margin: 0 auto;
  max-width: 1000px;
  min-width: 320px;
  position: relative;
}

.wrapper {
  padding: 30px 30px;
}
.header {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 25px;
  text-align: center;
}
.mtitle {
  margin-bottom: 25px;
  font-size: 20px;
  font-weight: bold;
}
.title {
  color: #444444;
}
.title span {
  color: #000;
}
.mb50 {
  margin-bottom: 25px;
}
.desc {
}
.footer {
  color: #444444;
  text-align: right;
}

@media screen and (max-width: 500px) {
  .page {
    font-size: 14px;
    line-height: 25px;
    width: 100%;
    .wrapper {
      padding: 30px 15px;
    }
    .header {
      font-size: 23px;
    }
    .mtitle {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agreement/agreement.vue